<app-modal-shell>
  <app-modal-body>
    <h5 class="text-xl font-medium leading-normal text-gray-800">You have been logged out due to inactivity.</h5>
  </app-modal-body>
  <app-modal-footer>
    <button type="button" class="
      px-6
      py-2.5
      bg-blue-600
      text-white
      font-medium
      text-xs
      leading-tight
      uppercase
      rounded
      shadow-md
      hover:bg-blue-700 hover:shadow-lg
      focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0
      active:bg-blue-800 active:shadow-lg
      transition
      duration-150
      ease-in-out
      ml-1" (click)="logout()">Ok</button>
  </app-modal-footer>
</app-modal-shell>